// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + "a2d1329d99cb440a9b94" + ".css";
};